<div [ngClass]="{'hidden': isCompact, 'search-container': !isCompact}">
  <div class="search-bar">
    <!-- TODO(design): busca com autocomplete + chat (composto bespoke), mantida nativa -->
    <input #searchInput type="text" class="search-input" (ngModelChange)="onTextChange($event)" [(ngModel)]="searchText"
      [matAutocomplete]="auto" [placeholder]="placeholder || 'Faça sua busca'" autofocus
      (keydown.enter)="openChatWithPrompt(searchText)" aria-label="Pesquisar" />

      <mat-autocomplete #auto="matAutocomplete" style="z-index:9999 !important;">
        @for (item of _listSearchBarStruct; track item) {
          <mat-option style="z-index:9999 !important;"
            (click)="selectValue(item.url)">
            <div class="itemName" style="z-index:9999 !important;">{{ item.nome }}</div>
            <div class="itemEmail" style="z-index:9999 !important;">{{ item.email | slice:0:30 }}</div>
            <div class="itemLinks" style="z-index:9999 !important;">
              {{ item.url.split('/')[1] }}
            </div>
          </mat-option>
        }
      </mat-autocomplete>

      <!-- Botão para abrir o Chat -->
      <!-- <button class="chat-open-btn" type="button" (click)="toggleChat(true)" aria-label="Abrir chat">
      <span class="mat-icon"><mat-icon>chat</mat-icon></span>
    </button> -->
  </div>
</div>

<!-- Botão flutuante opcional para abrir o Chat -->
<!-- <button class="floating-search-button" (click)="toggleChat(true)" aria-label="Abrir chat flutuante">
<span class="mat-icon"><mat-icon>chat</mat-icon></span>
</button> -->

<!-- OVERLAY DO CHAT -->
@if (isChatOpen) {
  <div class="overlay" (click)="toggleChat(false)">
    <div class="chat-modal" (click)="$event.stopPropagation()" role="dialog" aria-label="Assistente de Busca">
      <div class="chat-header">
        <div class="chat-title">Assistente</div>
        <button class="chat-close" (click)="toggleChat(false)" aria-label="Fechar">✕</button>
      </div>
      <div class="chat-body" #chatBody>
        <!-- LOOP DE MENSAGENS -->
        @for (m of messages; track m) {
          <div class="bubble" [ngClass]="m.role === 'user' ? 'user' : 'assistant'">
            <div class="bubble-role">{{ m.role === 'user' ? 'Você' : 'Assistente' }}</div>
            <!-- Texto (markdown já convertido) -->
            @if (m.content) {
              <div class="bubble-text" [innerHTML]="m.content"></div>
            }
            <!-- CARDS -->
            @if (m.cards?.length) {
              <div class="card-grid">
                @for (c of m.cards; track c) {
                  @for (link of c.links; track link) {
                    <button type="button" class="mini-card" (click)="openLink(link.url)" [attr.aria-label]="link.label">
                      <div class="card-header">
                        <div class="card-title">
                          {{ c.title }}
                          <!-- <span *ngIf="c.entidade" class="chip-entity">{{ c.entidade }}</span> -->
                        </div>
                        <!-- <div *ngIf="c.score !== undefined" class="chip-score">{{ c.score }}</div> -->
                      </div>
                      <div class="card-subtitle">{{ link.label }}</div>
                      @if (c.subtitle) {
                        <div class="card-snippet">{{ c.subtitle }}</div>
                      }
                      @if (c.snippet) {
                        <div class="card-snippet">{{ c.snippet }}</div>
                      }
                    </button>
                  }
                }
              </div>
            }
          </div>
        }
        <!-- Loading/Erro -->
        @if (loading) {
          <div class="loading">
            <div class="spinner"></div>
            <span>Gerando resposta…</span>
          </div>
        }
        @if (errorText) {
          <div class="error">{{ errorText }}</div>
        }
      </div>
      <!-- Entrada do Chat -->
      <form class="chat-input-row" (ngSubmit)="sendChat()" autocomplete="off">
        <textarea [(ngModel)]="chatInput" name="chatInput" class="chat-input" placeholder="Pergunte qualquer coisa…"
        rows="1" (keydown.enter)="onEnter($any($event))" aria-label="Digite sua pergunta"></textarea>
        <button class="send-btn" type="submit" [disabled]="!chatInput.trim() || loading">
          Enviar
        </button>
      </form>
    </div>
  </div>
}